import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AppliedFilterItem } from '../../helpers/filters/filter-types';

@Component({
  selector: 'muni-shared-applied-filters-popover',
  templateUrl: './applied-filters-popover.component.html',
  styleUrls: ['./applied-filters-popover.component.scss']
})
export class AppliedFiltersPopoverComponent {
  @Input()
  public clearFilter: () => unknown;

  @Input()
  public dateFilters$: Observable<AppliedFilterItem[]>;
  @Input()
  public savableFilters$: Observable<AppliedFilterItem[]>;
}
